import { render } from "./ChangeOwnPassowrdModal.vue?vue&type=template&id=309fad84&scoped=true"
import script from "./ChangeOwnPassowrdModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ChangeOwnPassowrdModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./ChangeOwnPassowrdModal.vue?vue&type=style&index=0&id=309fad84&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309fad84"]])

export default __exports__